import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class GpsService {

    constructor(private http: HttpClient) { }
  
      get(queryParams? : any){
          const params = new HttpParams({fromObject : queryParams})
          return this.http.get(urls.API_URL + urls.GPS, {params})
           .pipe(catchError(errorHandl));
        }
}
